// extracted by mini-css-extract-plugin
export default {"parent":"topRental_parent__9SaNv","title":"topRental_title__wITSN","chart":"topRental_chart__R8X07","total_Cars":"topRental_total_Cars__7zW5s"};